// Display-only tier data. Checkout pricing is re-looked-up server-side (functions/_lib/pricing.js) —
// this file must never be the source of truth for what a customer is charged. Keep priceCents and
// MULTI_TRAVELER_DISCOUNT_RATE in sync with that file.
//
// Pricing assumption (flag if wrong): Faye travel kit COGS ~$12-13/unit wholesale. Plus (+1 kit)
// priced +$15, Max (+2 kits) priced +$25 — Max's per-kit increment is lower to make the upgrade
// from Plus feel like a deal. Adjust priceCents/originalPriceCents below if the real kit cost differs.
export const TIERS = [
  {
    key: 'lite',
    name: 'Lite',
    tagline: 'The essentials, sorted',
    priceCents: 4990,
    esimGb: 5,
    loungeVisits: 1,
    travelKits: 0,
    features: ['1 airport lounge visit', '5GB eSIM data', 'Exclusive partner offers'],
    valueCents: 7000,
  },
  {
    key: 'plus',
    name: 'Plus',
    tagline: 'Double the data, same sweet lounge',
    priceCents: 7990,
    esimGb: 10,
    loungeVisits: 1,
    travelKits: 1,
    features: ['1 airport lounge visit', '10GB eSIM data', 'Faye travel kit', 'Exclusive partner offers'],
    valueCents: 10500,
    popular: true,
  },
  {
    key: 'max',
    name: 'Max',
    tagline: 'Lounge on the way out. Lounge on the way home.',
    priceCents: 11990,
    originalPriceCents: 12490,
    esimGb: 15,
    loungeVisits: 2,
    travelKits: 2,
    features: ['2 airport lounge visits', '15GB eSIM data', '2 Faye travel kits', 'Exclusive partner offers'],
    valueCents: 18500,
  },
];

// 10% off the whole order when buying bundles for more than one traveler at once.
export const MULTI_TRAVELER_DISCOUNT_RATE = 0.1;

export const getTier = (key) => TIERS.find((t) => t.key === key);

export const formatUsd = (cents) => `$${(cents / 100).toFixed(2)}`;

export const calculateOrderTotal = (tier, quantity) => {
  const subtotalCents = tier.priceCents * quantity;
  const multiTravelerDiscountCents =
    quantity >= 2 ? Math.round(subtotalCents * MULTI_TRAVELER_DISCOUNT_RATE) : 0;
  return {
    subtotalCents,
    multiTravelerDiscountCents,
    totalCents: subtotalCents - multiTravelerDiscountCents,
  };
};
